import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getDeviceStatus } from '@Actions';
import { DeviceStatus } from '@Types';
import { getValue } from '@Selectors';

type SensorStatusCheckerReturn = [DeviceStatus, () => Promise<void>];

const useSensorStatusChecker = (
	sensorId: string,
): SensorStatusCheckerReturn => {
	const dispatch = useDispatch();

	const {
		sensorDetails: { deviceStatus },
	} = useSelector(getValue);

	const handleGetDeviceStatus = async () => {
		dispatch(getDeviceStatus(sensorId));
	};

	// TODO: implement this with redux sagas and be sure to stop the cycle
	useEffect(() => {
		handleGetDeviceStatus();
		const interval = setInterval(handleGetDeviceStatus, 10000);
		return () => clearInterval(interval);
	}, []);

	return [deviceStatus, handleGetDeviceStatus];
};

export default useSensorStatusChecker;
